MoyaComponents.register('store.mypage.datepicker', [
	'https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/flatpickr.js',
	'https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/flatpickr.min.css',
	'https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.30.1/moment.min.js',
], (el) => {
	const parent = el.parentElement.parentElement;
	let defaultDates = null;
	const defaultDatesStr = el.dataset['defaultDate'];
	if (defaultDatesStr) {
		const split = defaultDatesStr.split(' ');
		if (split.length === 2) {
			defaultDates = split;
		}
	}

	function getThisMonth() {
		let start = moment().startOf('month').startOf('day').toDate();
		let end = moment().startOf('day').toDate();
		return [start, end];
	}

	function getLastMonth() {
		let start = moment().subtract(1, 'month').startOf('month').toDate();
		let end = moment().subtract(1, 'month').endOf('month').toDate();
		return [
			start,
			end,
		];
	}

	function getToday() {
		let end = moment().startOf('day').toDate();
		let start = moment().startOf('day').toDate();
		return [start, end];
	}

	function getLastYear() {
		let start = moment().subtract(1, 'year').startOf('year').toDate();
		let end = moment().subtract(1, 'year').endOf('year').toDate();
		return [
			start,
			end,
		];
	}

	function getClear() {
		return [
			null,
		];
	}

	function getIcelandic() {
		return {
			weekdays: {
				shorthand: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
				longhand: [
					'Sunnudagur',
					'Mánudagur',
					'Þriðjudagur',
					'Miðvikudagur',
					'Fimmtudagur',
					'Föstudagur',
					'Laugardagur',
				],
			},
			months: {
				shorthand: [
					'Jan',
					'Feb',
					'Mar',
					'Apr',
					'Maí',
					'Jún',
					'Júl',
					'Ágú',
					'Sep',
					'Okt',
					'Nóv',
					'Des',
				],
				longhand: [
					'Janúar',
					'Febrúar',
					'Mars',
					'Apríl',
					'Maí',
					'Júní',
					'Júlí',
					'Ágúst',
					'September',
					'Október',
					'Nóvember',
					'Desember',
				],
			},
			ordinal: function () {
				return '.';
			},
			firstDayOfWeek: 1,
			rangeSeparator: ' til ',
			weekAbbreviation: 'vika',
			yearAriaLabel: 'Ár',
			time_24hr: true,
		};
	}

	flatpickr(parent, {
		mode: 'range',
		plugins: umbFlatpickrPlugins,
		ranges: {
			'Í dag': getToday(),
			'Þennan mánuð': getThisMonth(),
			'Síðasta mánuð': getLastMonth(),
			'Síðasta ár': getLastYear(),
			'Hreinsa val': getClear(),
		},
		rangesOnly: false,
		rangesAllowCustom: true,
		rangesCustomLabel: 'Velja dagsetningu',
		dateFormat: 'd.m.Y',
		locale: getIcelandic(),
		wrap: true,
		minDate: el.getAttribute('data-datepicker-min'),
		maxDate: el.getAttribute('data-datepicker-max'),
		defaultDate: defaultDates,
		monthSelectorType: 'static',
		yearSelectorType: 'static',
		prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
			'<path d="M15.4199 7.41L10.8299 12L15.4199 16.59L13.9999 18L7.99992 12L13.9999 6L15.4199 7.41Z" fill="#FF6600"/>\n' +
			'</svg>',
		nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
			'<path d="M15.4199 7.41L10.8299 12L15.4199 16.59L13.9999 18L7.99992 12L13.9999 6L15.4199 7.41Z" fill="#FF6600"/>\n' +
			'</svg>',
		onChange: function (selectedDates) {
			if (selectedDates.length === 0) {
				el.removeAttribute('data-from');
				el.removeAttribute('data-to');
				parent.classList.remove('active');
			}
			else if (selectedDates.length === 1) {
				el.classList.add('selecting');
			}
			else if (selectedDates.length === 2) {
				el.classList.remove('selecting');
				parent.classList.add('active');
				el.setAttribute('data-from', Date.parse(selectedDates[0]) / 1000);
				el.setAttribute('data-to', Date.parse(selectedDates[1]) / 1000);
			}
		},
	});
});
